module.exports = __webpack_public_path__ + "img/pic_family.c29b123a.jpg";